import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_SERVER_ADDRESS } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContenidoEstaticoService {

  constructor(private http: HttpClient) { }

  getAyuda(lang: string | null): Observable<string | null> {
    const url = lang ? `${API_SERVER_ADDRESS}/v1/app-ayuda?lang=${lang}` : `${API_SERVER_ADDRESS}/v1/ayuda`;
    return this.http.get(url, { responseType: 'text' })
      .pipe(
        catchError(err => {
          console.error('Error fetching help from API', err);
          return of(null);
        })
      );
  }

  getTerminosLegales(lang: string | null): Observable<string | null> {
    const url = lang ? `${API_SERVER_ADDRESS}/v1/app-terminos-legales?lang=${lang}` : `${API_SERVER_ADDRESS}/v1/app-terminos-legales`;
    return this.http.get(url, { responseType: 'text' })
      .pipe(
        catchError(err => {
          console.error('Error fetching terminos-legales from API', err);
          return of(null);
        })
      );
  }

  getPrivacidad(lang: string | null): Observable<string | null> {
    const url = lang ? `${API_SERVER_ADDRESS}/v1/app-privacidad?lang=${lang}` : `${API_SERVER_ADDRESS}/v1/app-privacidad`;
    return this.http.get(url, { responseType: 'text' })
      .pipe(
        catchError(err => {
          console.error('Error fetching privacidad from API', err);
          return of(null);
        })
      );
  }
}
